import { Component, input } from '@angular/core';

@Component({
  selector: 'app-gold-line',
  templateUrl: './gold-line.component.html',
  styleUrl: './gold-line.component.scss'
})
export class GoldLineComponent {
  input_position = input.required<String>();


}
